import client from "./client";

export const fetchConditions = (resortId) => client.get(`/conditions/${resortId}`).then((r) => r.data);

export const reportBaseDepth = (resortId, baseDepthInches) =>
  client.post(`/conditions/${resortId}/report`, { baseDepthInches }).then((r) => r.data);
